import React, { useEffect, useRef } from 'react'
import Hls from 'hls.js'
import { attachHlsSource } from './helpers'

export default function VideoPlayer({ controls = true, src, videoStyle, id, poster }) {
  const videoRef = useRef(null)

  useEffect(() => {
    let hls
    if (videoRef.current) {
      hls = attachHlsSource({ player: videoRef.current, src, Hls })
    }

    return () => {
      if (hls) {
        hls.destroy()
      }
    }
  }, [videoRef])

  return <video id={id} controls={controls} ref={videoRef} style={videoStyle} poster={poster} />
}
